/**
 * This function handles PayU hosted checkout by auto-submitting form to their secure page
 * @param {*} url - PayU hosted checkout URL
 * @param {*} payload - Form data (key, txnid, amount, hash, etc.)
 * @param {*} txnId - Transaction ID
 */
export const redirectToHostedCheckout = (url, payload, txnId) => {
  // Create form element
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url;
  form.style.display = 'none';

  // Add all payload fields as hidden inputs
  Object.keys(payload).forEach((key) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = payload[key];
    form.appendChild(input);
  });

  // Append form to body and submit
  document.body.appendChild(form);
  form.submit();

  // Note: User will be redirected to PayU's page and leave our app
  // They will return via surl/furl callback URLs configured in backend
};
